import React, { useState, useEffect, useRef } from "react";
import PageTitle from "../../../module/pageTitle";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import TextEditor from "../../../Component/textEditor";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ImgPickerAndViewer from "../../../Component/imgPickerAndViewer";
import {
  containsNumber,
  length_Four,
  length_Thirteen,
  validateAgeGrp,
  validateDimension,
  validateIsFileImageType,
  validateIsFileVideoType,
  validateValueWithoutSpace,
} from "../../../Utils/validators";
import {
  validateIsFileImageTypeErrMsg,
  validateIsFileVideoTypeErrMsg,
  validateIsNumberOnlyErrMsg,
} from "../../../Utils/errorMsg";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  showSnackbar,
  hideSnackbar,
} from "../../../store/slices/snackbarSlice";
import {
  addProduct,
  getAgeGroupList,
  getCategoryList,
  getGeneralProductType,
  getGSTList,
  getLanguageList,
  getProductTypeList,
  getTagOptionList,
  set,
  getSellingSource,
  uploadMedia,
  getProductList,
  booksAnswerkeyUpload,
} from "../adminSlice";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";

const AddProduct = () => {
  const initialVal = [
    {
      url: "",
      order: "",
      type: 1,
      imagePrevUrl: "",
    },
  ];
  const dispatch: Function = useDispatch<AppDispatch>();
  const [imgVideoArr, setimgVideoArr] = useState<any>(initialVal);
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [tagOptionList, setTagOptionList] = useState<any>([]);
  const [newTagArr, setNewTagArr] = useState<any>([]);
  const [initialAge, setInitialAge] = useState<any>("");
  const [ageGroupList, setAgeGroupList] = useState<any>([]);
  const [ageGroup, setAgeGroup] = useState<any>([]);
  const [productName, setProductName] = useState<any>("");
  const [sellingPrice, setSellingPrice] = useState<any>("");
  const [offerPrice, setOfferPrice] = useState<any>("");
  const [stockReminder, setStockReminder] = useState<any>("");
  const [isbnNo, setisbnNo] = useState<any>("");
  const [briefDesc, setBriefDesc] = useState<any>("");
  const [productDesc, setProductDesc] = useState<any>("");
  const [additionInfo, setAdditionInfo] = useState<any>("");
  const [languageList, setLanguageList] = useState<any>([]);
  const [language, setLanguage] = useState<any>("");
  const [isTaxable, setisTaxable] = useState<boolean>(false);
  const [GSTPercentage, setGSTPercentage] = useState<any>("");
  const [diamension, setdiamension] = useState<string>("");
  const [totalpages, settotalpages] = useState<string>("");
  const [GSTList, setGSTList] = useState<any>([]);
  const [video, setVideo] = useState<any>("");
  const [videoPreview, setVideoPreview] = useState<any>("");
  const [sellingSource, setSellingSource] = useState<any>([]);
  const [allCheck, setAllCheck] = useState(false);
  const [sourcePrice, setSourcePrice] = useState("");
  const [tagCheck, setTagCheck] = useState("");
  const [buyTogaterProductList, setBuyTogaterProductList] = useState<any>([]);
  const [buyTogatherProduct, setBuyTogatherProduct] = useState<any>("");
  const [selectedBuyProduct, setSelectedBuyProduct] = useState<any>([]);
  const [answerKeyURL, setAnswerKeyURL] = useState<any>("");
  const generateId = () => {
    return (
      Date.now().toString(36) +
      Math.random().toString(36).substring(2)
    );
  };
  const initialValDescImg = [
    {
      id: generateId(),
      image: "",
      order: "",
      text: "",
      type: 1,
      imagePreview: "",
    },
  ];
  const [descriptionImages, setdescriptionImages] =
    useState<any>(initialValDescImg);

  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      }),
    );
    dispatch(
      getAgeGroupList({
        callback: (res: any) => {
          const newArr = res?.data?.map((item: any) => {
            return {
              _id: item?._id,
              name: item?.name,
              isChecked: false,
            };
          });
          setAgeGroupList(newArr);
        },
        errorCallback: () => { },
      }),
    );
    dispatch(
      getLanguageList({
        callback: (res: any) => {
          setLanguageList(res?.data);
        },
        errorCallback: () => { },
      }),
    );
    dispatch(
      getGSTList({
        callback: (res: any) => {
          setGSTList(res?.data);
        },
        errorCallback: () => { },
      }),
    );
    const postData: any = {};
    dispatch(
      getProductList({
        params: postData,
        callback: (res: any) => {
          setBuyTogaterProductList(res);
        },
        errorCallback: (error: any) => { },
      }),
    );
    getTagOptions();
    getSourceSelling();
  }, []);

  const getTagOptions = () => {
    dispatch(
      getTagOptionList({
        callback: (res: any) => {
          setTagOptionList(res?.data);
        },
        errorCallback: () => { },
      }),
    );
  };
  const getSourceSelling = () => {
    dispatch(
      getSellingSource({
        callback: (res: any) => {
          if (res?.data?.length > 0) {
            const newArr = res?.data?.map((item: any) => {
              return {
                _id: item?._id,
                name: item?.name,
                price: "",
                isChecked: false,
              };
            });
            setSellingSource(newArr);
          }
        },
        errorCallback(error) { },
      }),
    );
  };
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const productVideoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [imgVideoArr]);

  useEffect(() => {
    if (productVideoRef.current) {
      productVideoRef.current.load();
    }
  }, [videoPreview]);
  const handleAllCheck = (value: any) => {
    let newArray = JSON.parse(JSON.stringify(sellingSource));
    if (value.target.checked) {
      newArray.map((item: any) => {
        Object.assign(item, { isChecked: value.target.checked });
        setAllCheck(value.target.checked);
        return item;
      });
    } else {
      newArray.map((item: any) => {
        Object.assign(item, {
          isChecked: value.target.checked,
          price: "",
        });
        setAllCheck(value.target.checked);
        setSourcePrice("");
        return item;
      });
    }
    setSellingSource(newArray);
  };
  const handleSourcePrice = (value: any) => {
    const val = value.replace(/\D/g, "");
    if (allCheck) {
      const newArr = JSON.parse(JSON.stringify(sellingSource));
      newArr.map((item: any) => {
        Object.assign(item, { price: val });
        setSourcePrice(item?.price);
        return item;
      });
      setSellingSource(newArr);
    } else {
      setSourcePrice(val);
    }
  };

  const onChangeSellingSource = (
    val: any,
    key: string,
    index: number,
    item: any,
  ) => {
    const newArr = JSON.parse(JSON.stringify(sellingSource));
    if (key === "isChecked") {
      newArr[index][key] = val?.target?.checked;
      setSellingSource(newArr);
    } else {
      const value = val.target.value.replace(/\D/g, "");
      newArr[index][key] = value;
      setSellingSource(newArr);
    }
  };

  const onPressAdd = () => {
    setimgVideoArr([...imgVideoArr, initialVal[0]]);
  };
  const handleClose = (index: any) => {
    const newArray = [...imgVideoArr];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    setimgVideoArr(newArray);
  };

  const onchangeImgVideo = (value: any, index: any, key: any, doctype: any) => {
    const newArray = [...imgVideoArr];
    if (key === "url") {
      if (doctype === "image") {
        if (!validateIsFileImageType(value)) {
          return;
        } else {
          const reader = new FileReader();
          const file = value.target.files[0];
          reader.onloadend = () => {
            newArray[index]["imagePrevUrl"] = reader.result;
            setimgVideoArr(newArray);
          };
          reader.readAsDataURL(file);
          const imagePayload = {
            file: file,
            type: "product",
            format: "1",
          };
          dispatch(
            uploadMedia({
              params: imagePayload,
              callback: (res: any) => {
                if (res?.data) {
                  newArray[index][key] = res?.data?.name;
                  setimgVideoArr(newArray);
                }
              },
              errorCallback: () => { },
            }),
          );
        }
      } else if (doctype === "video") {
        if (!validateIsFileVideoType(value)) {
          return;
        } else {
          const reader = new FileReader();
          const file = value.target.files[0];
          reader.onloadend = () => {
            newArray[index][key] = reader.result;
            setimgVideoArr(newArray);
          };
          reader.readAsDataURL(file);
          const imagePayload = {
            file: file,
            type: "product",
            format: "2",
          };
          dispatch(
            uploadMedia({
              params: imagePayload,
              callback: (res: any) => {
                if (res?.data) {
                  newArray[index][key] = res?.data?.name;
                  setimgVideoArr(newArray);
                }
              },
              errorCallback: () => { },
            }),
          );
        }
      }
    } else if (key === "order") {
      if (validateAgeGrp(value)) {
        newArray[index][key] = value;
        setimgVideoArr(newArray);
      }
      // newArray[index][key] = value?parseInt(value):"";
    } else if (key === "type") {
      const newType = parseInt(value);
      if (newArray[index].type !== newType) {
        newArray[index].url = "";
        newArray[index].type = newType;
        setimgVideoArr(newArray);
      }
    }
  };

  const changeCheckBox = (event: any, index: any) => {
    let data = newTagArr;
    let i = data.findIndex((item: any) => item === event.target.id);
    if (i < 0) {
      data.push(event.target.id);
    } else {
      data.splice(i, 1);
    }
    setNewTagArr(data);
  };
  const onchangeProductType = (value: any) => {
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      }),
    );
    setProductType(value);
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);
  };
  // const onchangeAgeGrp = (value: any) => {
  //   setAgeGroup(value);
  // };
  const onchangeInitialAge = (value: any) => {
    setInitialAge(value);
  };
  const oncheckAgeGrp = (val: any, key: string, index: number, item: any) => {
    const newArr = JSON.parse(JSON.stringify(ageGroupList));
    if (key === "isChecked") {
      newArr[index][key] = val?.target?.checked;
      setAgeGroupList(newArr);
    } else {
      const value = val.target.value.replace(/\D/g, "");
      newArr[index][key] = value;
      setAgeGroupList(newArr);
    }
  };
  const onchangeLanguage = (value: any) => {
    setLanguage(value);
  };
  const onchangeProductName = (value: any) => {
    setProductName(value);
  };
  const onchangeBuyTogatherProduct = (value: any, action: any) => {
    if (action === "add") {
      setBuyTogatherProduct(value);
      setSelectedBuyProduct((prev: any) => {
        const alreadyExists = prev?.some(
          (item: any) => item?.name === value?.name,
        );
        if (alreadyExists) {
          dispatch(
            showSnackbar({ message: "Already selected", type: "error" }),
          );
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
          return prev;
        }
        return [...prev, value];
      });
    } else if (action === "remove") {
      setSelectedBuyProduct((prev: any) =>
        prev.filter((item: any) => item?._id !== value?._id),
      );
    }
  };

  const onchnageSellingPrice = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        setSellingPrice(value);
      }
    } else {
      setSellingPrice(value);
    }
  };

  const onchnageOfferPrice = (value: any) => {
    const offerPrice = Number(value);
    const sellPrice = Number(sellingPrice);
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else if (offerPrice > sellPrice) {
        dispatch(
          showSnackbar({
            message:
              "Please Enter valid Offer pirce!!, Offer Price shoould not be greater than Selling Price",
            type: "error",
          }),
        );
        setTimeout(() => {
          hideSnackbar();
        }, 5000);
        return;
      } else {
        setOfferPrice(value);
      }
    } else {
      setOfferPrice(value);
    }
  };
  const onchaangeStockReminder = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        setStockReminder(value);
      }
    } else {
      setStockReminder(value);
    }
  };
  const onchangeIsbnNo = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        if (value?.length < length_Thirteen) {
          setisbnNo(value);
        }
      }
    } else {
      setisbnNo(value);
    }
  };
  const onchangeDaimension = (value: any) => {
    setdiamension(value);
    // if (value !== "") {
    //   if (!validateDimension(value)) {
    //     return;
    //   } else if (!validateValueWithoutSpace(value)) {
    //     return;
    //   } else {
    //     setdiamension(value);
    //   }
    // } else {
    //   setdiamension(value);
    // }
  };
  const onchangeTotalpages = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        settotalpages(value);
      }
    } else {
      settotalpages(value);
    }
  };

  const onchangeBriefDesc = (value: any) => {
    setBriefDesc(value);
  };
  const onchangeProductDesc = (value: any) => {
    setProductDesc(value);
  };
  const onchangeAdditionInfo = (value: any) => {
    setAdditionInfo(value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const newArr = sellingSource?.filter(
      (item: any) => item?.isChecked === true,
    );
    const updatedDescriptionImages = descriptionImages.map((item: any) => {
      const { imagePreview, id, ...rest } = item;
      return rest;
    });
    const updatedFileImages = imgVideoArr.map((item: any) => {
      const { imagePrevUrl, ...rest } = item;
      return rest;
    });
    const ageGroupId = ageGroupList?.filter(
      (item: any) => item?.isChecked === true,
    );
    const postData: any = {
      name: productName,
      productTypeId: productType?._id,
      categoryId: category?._id,
      // ageGroupId: ageGroupId,
      sellingPrice: sellingPrice,
      offerPrice: offerPrice,
      stockReminder: stockReminder,
      uniqueNo: isbnNo,
      tags: newTagArr,
      file: updatedFileImages,
      languageId: language?._id,
      isTaxable: isTaxable,
      descriptionImages: updatedDescriptionImages,
      diamension: diamension,
    };
    // if (initialAge) {
    //   postData["age"] = initialAge;
    // }
    if (ageGroupId?.length > 0) {
      const arr = ageGroupId?.map((item: any) => item?._id);
      postData["ageGroupId"] = arr;
    }
    if (isTaxable) {
      postData["GSTPercentage"] = "" + GSTPercentage?.percentage;
    }
    if (totalpages) {
      postData["pages"] = totalpages;
    }
    if (selectedBuyProduct?.length > 0) {
      const arr = selectedBuyProduct?.map((item: any) => item?._id);
      postData["buyTogether"] = arr;
    }
    if (briefDesc) {
      postData["briefDescription"] = briefDesc;
    }
    if (productDesc) {
      postData["productDescription"] = productDesc;
    }
    if (additionInfo) {
      postData["additionalInfo"] = additionInfo;
    }
    if (video) {
      postData["video"] = video;
    }
    if (
      postData["stockReminder"] === null ||
      postData["stockReminder"] === undefined ||
      postData["stockReminder"] === ""
    ) {
      delete postData["stockReminder"];
    }
    if (newTagArr.length === 0) {
      delete postData["tags"];
    }
    if (
      postData["additionalInfo"] === null ||
      postData["additionalInfo"] === undefined ||
      postData["additionalInfo"] === ""
    ) {
      delete postData["additionalInfo"];
    }
    if (newArr?.length > 0) {
      const arr = newArr?.map((item: any) => {
        return {
          sourceId: item?._id,
          sourceName: item?.name,
          price: Number(item?.price),
        };
      });
      postData["sourcePrice"] = arr;
    }
    if (answerKeyURL) {
      postData["answerKey"] = answerKeyURL;
    }
    dispatch(
      addProduct({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setProductName("");
            setProductType("");
            setCategory("");
            setAgeGroup([]);
            setAgeGroupList([]);
            setSellingPrice("");
            setOfferPrice("");
            setStockReminder("");
            setisbnNo("");
            setBriefDesc("");
            setProductDesc("");
            setAdditionInfo("");
            setNewTagArr([]);
            setimgVideoArr(initialVal);
            setLanguage("");
            setdiamension("");
            setLanguage("");
            settotalpages("");
            setGSTPercentage("");
            setVideo("");
            setdescriptionImages(initialValDescImg);
            setAllCheck(false);
            getTagOptions();
            setTagCheck("");
            getSourceSelling();
            dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
            setVideoPreview("");
            setInitialAge("");
            setSelectedBuyProduct([]);
            setBuyTogaterProductList([]);
            setAnswerKeyURL("");
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(
            showSnackbar({
              message: error?.data?.msg,
              type: error?.data?.type,
            }),
          );
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      }),
    );
  };
  const handleProductVideo = (value: any) => {
    if (!validateIsFileVideoType(value)) {
      return;
    } else {
      const reader = new FileReader();
      const file = value.target.files[0];
      reader.onloadend = () => {
        // newArray[index][key] = reader.result;
        // if (typeof reader.result === "string") {
        setVideoPreview(reader.result);
        // }
      };
      reader.readAsDataURL(file);
      const imagePayload = {
        file: file,
        type: "description",
        format: "2",
      };
      dispatch(
        uploadMedia({
          params: imagePayload,
          callback: (res: any) => {
            if (res?.data) {
              setVideo(res?.data?.name);
            }
          },
          errorCallback: () => { },
        }),
      );
    }
  };
  const isEditorEmpty = (html: string = ""): boolean => {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    const text = (temp.textContent ?? "").replace(/\u00A0/g, "").trim();

    return text.length === 0;
  };

  const validations = () => {
    let valid = false;
    imgVideoArr.map((item: any) => {
      if (item?.url === "" || item?.order === "") {
        valid = true;
      }
    });
    descriptionImages.map((data: any) => {
      if (
        data?.image === "" ||
        data?.order === "" ||
        isEditorEmpty(data?.text)
      ) {
        valid = true;
      }
    });
    let isSellingSourse = sellingSource.some(
      (item: any) => item?.isChecked === true && item?.price !== "",
    );
    if (productType === "") {
      valid = true;
    }
    if (category === "") {
      valid = true;
    }
    if (productName === "") {
      valid = true;
    }
    if (initialAge === "") {
      valid = true;
    }
    if (!(ageGroupList?.length > 0)) {
      valid = true;
    }
    if (sellingPrice === "") {
      valid = true;
    }
    if (offerPrice === "") {
      valid = true;
    }
    if (isbnNo === "") {
      valid = true;
    }
    if (!isSellingSourse) {
      valid = true;
    }
    // if (briefDesc === "") {
    //   valid = true;
    // }
    // if (productDesc === "") {
    //   valid = true;
    // }

    return valid;
  };
  const onchangeProductImage = (value: any, index: any, key: any) => {
    // const newArray = [...descriptionImages];
    if (key === "image") {
      if (!validateIsFileImageType(value)) {
        return;
      } else {
        const reader = new FileReader();
        const file = value.target.files[0];
        reader.onloadend = () => {
          // newArray[index]["imagePreview"] = reader.result;
          // setdescriptionImages(newArray);
          setdescriptionImages((prev: any) =>
            prev.map((item: any, i: number) =>
              i === index ? { ...item, imagePreview: reader.result } : item,
            ),
          );
        };
        reader.readAsDataURL(file);
        const imagePayload = {
          file: file,
          type: "description",
          format: "1",
        };
        dispatch(
          uploadMedia({
            params: imagePayload,
            callback: (res: any) => {
              if (res?.data) {
                setdescriptionImages((prev: any) =>
                  prev.map((item: any, i: any) =>
                    i === index ? { ...item, image: res.data.name } : item,
                  ),
                );
                // newArray[index][key] = res?.data?.name;
                // setdescriptionImages(newArray);
              }
            },
            errorCallback: () => { },
          }),
        );
      }
    } else if (key === "order") {
      if (validateAgeGrp(value)) {
        setdescriptionImages((prev: any) =>
          prev.map((item: any, i: any) =>
            i === index ? { ...item, order: value } : item,
          ),
        );
        // newArray[index][key] = value;
        // setdescriptionImages(newArray);
      }
    } else if (key === "text") {
      setdescriptionImages((prev: any) =>
        prev.map((item: any, i: any) =>
          i === index ? { ...item, text: value } : item,
        ),
      );
      // newArray[index][key] = value;
      // setdescriptionImages(newArray);
    }
  };

  const onPressAddProductImg = () => {
    setdescriptionImages((prev: any) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        image: "",
        imagePreview: "",
        order: "",
        text: "",
      },
    ]);
    // setdescriptionImages([...descriptionImages, initialValDescImg[0]]);
  };
  const handleCloseAddProductImg = (index: any) => {
    const newArray = [...descriptionImages];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    setdescriptionImages(newArray);
  };
  const onchangeAnswerKeyPdf = (e: any) => {
    const file = e?.target?.files?.[0];

    if (!file) return;

    if (file.type !== "application/pdf") {
      dispatch(
        showSnackbar({
          message: "Please upload only PDF file",
          type: "error",
        }),
      );
      setTimeout(() => {
        dispatch(hideSnackbar())
      }, 5000);
      e.target.value = "";
      return;
    }
    // const MAX_FILE_SIZE = 50 * 1024 * 1024;
    // if (file.size > MAX_FILE_SIZE) {
    //   dispatch(
    //     showSnackbar({
    //       message: "PDF file size should not exceed 50 MB",
    //       type: "error",
    //     }),
    //   );
    //   setTimeout(() => {
    //     dispatch(hideSnackbar())
    //   }, 5000);
    //   e.target.value = "";
    //   return;
    // }

    dispatch(
      booksAnswerkeyUpload({
        params: file,
        callback: (res: any) => {
          if (res?.status === "success") {
            setAnswerKeyURL(res?.data?.name);
          }
        },
        errorCallback: (error: any) => {
          dispatch(
            showSnackbar({
              message: error?.message || "PDF upload failed",
              type: "error",
            }),
          );
          setTimeout(() => {
            dispatch(hideSnackbar())
          }, 5000);
        },
      }),
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Add Product"} />
      </div>
      <div className="formDiv">
        <div className="">
          <form onSubmit={handleSubmit}>
            <div className="row bxshadow p-2 borderRadius mb-4">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product type"} isRequired />
                <DropdownWithClear
                  labelName={"Select Product type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product category "} isRequired />
                <DropdownWithClear
                  labelName={"Select Product category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Initial Age "} isRequired />
                <InputField
                  key={"ex2"}
                  placeholder={"Enter Initial Age (0-2)"}
                  setInputText={(value: any) => onchangeInitialAge(value)}
                  value={initialAge}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Age group"} isRequired />
                <div className="ageGroupcheckbox d-flex align-items center p-2">
                  {ageGroupList?.map((item: any, index: number) => (
                    <>
                      <input
                        className="check me-1"
                        type="checkbox"
                        value={item?.isChecked}
                        checked={item?.isChecked}
                        id={`defaultCheck${item?._id}`}
                        onChange={(value) => {
                          oncheckAgeGrp(value, "isChecked", index, item);
                        }}
                      />
                      <span className="checkVal me-3">{item?.name}</span>
                    </>
                  ))}
                </div>
                {/* <DropdownWithClear
                  labelName={"Select Age group"}
                  setInputText={(value: any) => onchangeAgeGrp(value)}
                  options={ageGroupList}
                  value={ageGroup}
                /> */}
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product name "} isRequired />
                <InputField
                  key={"ex2"}
                  placeholder={"Enter Product name "}
                  setInputText={(value: any) => onchangeProductName(value)}
                  value={productName}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Selling price (MRP)"} isRequired />
                <InputField
                  key={"ex2"}
                  placeholder={"Enter Selling price"}
                  setInputText={(value: any) => onchnageSellingPrice(value)}
                  value={sellingPrice}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput
                  labelName={"Offer price (Discount Price"}
                  isRequired
                />
                <InputField
                  key={"ex2"}
                  placeholder={"Enter offer price "}
                  setInputText={(value: any) => onchnageOfferPrice(value)}
                  value={offerPrice}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Stock Reminder "} />
                <InputField
                  key={"ex2"}
                  placeholder={"Enter Stock Reminder "}
                  setInputText={(value: any) => onchaangeStockReminder(value)}
                  value={stockReminder}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"ISBN Number"} isRequired />
                <InputField
                  placeholder={"Enter ISBN Number"}
                  setInputText={(value: any) => onchangeIsbnNo(value)}
                  value={isbnNo}
                  maxLength={length_Thirteen}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Language"} />
                <DropdownWithClear
                  labelName={"Select Language"}
                  setInputText={(value: any) => onchangeLanguage(value)}
                  options={languageList}
                  value={language}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Dimensions (01 x 01 x 1.0 cm.)"} />
                <InputField
                  placeholder={"Enter Dimensions (01 x 01 x 1.0 cm.)"}
                  setInputText={(value: any) => onchangeDaimension(value)}
                  value={diamension}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Total pages"} />
                <InputField
                  placeholder={"Enter total pages"}
                  // setInputText={(value: any) => settotalpages(value)}
                  setInputText={(value: any) => onchangeTotalpages(value)}
                  value={totalpages}
                  maxLength={length_Four}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Is Taxable"} />
                <div>
                  <span className="fw-bold">
                    <input
                      type="radio"
                      value="true"
                      name="isTaxable"
                      checked={isTaxable ? true : false}
                      onChange={() => setisTaxable(true)}
                    />{" "}
                    Yes
                  </span>
                  <span className="fw-bold ms-3">
                    <input
                      type="radio"
                      value="false"
                      name="isTaxable"
                      checked={!isTaxable ? true : false}
                      onChange={() => setisTaxable(false)}
                    />{" "}
                    No
                  </span>
                </div>
              </div>
              {isTaxable ? (
                <div className="col-md-4 mb-3">
                  <LabelInput labelName={"GST Percentage"} />
                  <DropdownWithClear
                    labelName={"Select GST Percentage"}
                    setInputText={(value: any) => setGSTPercentage(value)}
                    options={GSTList}
                    value={GSTPercentage}
                  />
                </div>
              ) : null}
              <div className="col-md-8 mb-3">
                <div className="d-flex align-items-center">
                  <LabelInput labelName={"Answer Key PDF File"} />
                  {/* <span className="required font12 fw-bold ms-2 mb-2">(PDF files larger than 50 MB are not allowed)</span> */}
                </div>
                <div className=" d-flex align-items-center gap-2">
                  <ImagePickerAndViewer
                    value={answerKeyURL}
                    handleChange={onchangeAnswerKeyPdf}
                    htmlFor="answer-key-pdf-upload"
                    doctype="pdf"
                  />
                  {answerKeyURL && (
                    <div className="mt-2 text-success small">
                      ✓ {answerKeyURL} uploaded successfully
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row bxshadow p-2 borderRadius mb-4">
              <div className="col-md-4 mb-3">
                <LabelInput
                  labelName={"Buy Togather Product (Select Only Two)"}
                />
                <DropdownWithClear
                  labelName={"Select Buy Togather Product"}
                  setInputText={(value: any) =>
                    onchangeBuyTogatherProduct(value, "add")
                  }
                  options={buyTogaterProductList}
                  value={buyTogatherProduct}
                  disabled={selectedBuyProduct?.length === 2}
                />
              </div>
              {selectedBuyProduct?.length > 0 && (
                <div className="col-md-8 mb-3">
                  <LabelInput labelName={"Selected Buy Togather Product"} />
                  <div className="d-flex flex-wrap">
                    {selectedBuyProduct.map((item: any, index: any) => {
                      return (
                        <div key={index} className="me-3 mb-3">
                          <span className="badge bg-secondary position-relative colorTheme1 font12">
                            {item?.name}
                            <span
                              className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                              onClick={() =>
                                onchangeBuyTogatherProduct(item, "remove")
                              }
                            >
                              X
                            </span>
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            <div className="row bxshadow p-2 borderRadius mb-4">
              <div className="mb-3">
                <LabelInput labelName={"Selling Source"} isRequired />
              </div>
              <div className="">
                <div className="col-md-8 d-flex justify-content-start align-items-center mb-3">
                  <div className="d-flex e-input align-items-center mx-2 mb-3">
                    <input
                      className="check"
                      type="checkbox"
                      checked={allCheck}
                      onChange={(value) => {
                        handleAllCheck(value);
                      }}
                    />
                    <span className="checkVal ms-2">
                      <b>Check All</b>
                    </span>
                  </div>
                  <div className="">
                    <InputField
                      placeholder={"Enter Price"}
                      value={sourcePrice}
                      setInputText={(value: any) => handleSourcePrice(value)}
                      disabled={!allCheck}
                      maxLength={5}
                    />
                  </div>
                </div>
                <div className="row">
                  {sellingSource?.map((item: any, index: any) => {
                    return (
                      <div className="col-md-4 mb-3" key={index}>
                        <div className="d-flex justify-content-between bxshadow p-3 borderRadius">
                          <div className="me-1">
                            <LabelInput labelName={"Source"} />
                            <div className="d-flex e-input align-items-center">
                              <input
                                className="check"
                                type="checkbox"
                                value={item?.isChecked}
                                checked={item?.isChecked}
                                id={`defaultCheck${item?._id}`}
                                onChange={(val) =>
                                  onChangeSellingSource(
                                    val,
                                    "isChecked",
                                    index,
                                    item,
                                  )
                                }
                              />
                              <span className="checkVal ms-2">
                                {item?.name}
                              </span>
                            </div>
                          </div>
                          <div className="col-7">
                            <LabelInput labelName={"Price"} />
                            <input
                              type="text"
                              className="form-control"
                              placeholder={"Enter Price"}
                              onChange={(val: any) =>
                                onChangeSellingSource(val, "price", index, item)
                              }
                              value={item?.price}
                              maxLength={5}
                              disabled={!item?.isChecked}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="">
              <LabelInput labelName={"Upload Images/video"} isRequired />
              <div className="row g-5 mb-3">
                {imgVideoArr.map((item: any, index: any) => {
                  const { url, order, type, imagePrevUrl } = item;
                  return (
                    <div className="col-md-6">
                      <div
                        className="row bxshadow p-2 borderRadius position-relative"
                        key={index}
                      >
                        <div className="col-md-7 mb-3">
                          <div className="row">
                            <div className="col-md-4 mb-2">
                              <span className="fw-bold">
                                <input
                                  type="radio"
                                  value={1}
                                  name={"type" + index}
                                  checked={type === 1 ? true : false}
                                  onChange={() =>
                                    onchangeImgVideo(1, index, "type", "")
                                  }
                                />{" "}
                                Image
                              </span>
                            </div>
                            <div className="col-md-4 mb-2">
                              <span className="fw-bold">
                                <input
                                  type="radio"
                                  value={2}
                                  name={"type" + index}
                                  checked={type === 2 ? true : false}
                                  onChange={() =>
                                    onchangeImgVideo(2, index, "type", "")
                                  }
                                />{" "}
                                Video
                              </span>
                            </div>
                          </div>
                          <div className="col-md-6 mb-4">
                            {type === 1 ? (
                              <ImagePickerAndViewer
                                value={imagePrevUrl ? imagePrevUrl : url}
                                handleChange={(value: any) =>
                                  onchangeImgVideo(value, index, "url", "image")
                                }
                                htmlFor={`image-upload-${index}`}
                                doctype={""}
                              />
                            ) : type === 2 ? (
                              <div className="d-flex">
                                <ImagePickerAndViewer
                                  value={imagePrevUrl ? imagePrevUrl : url}
                                  handleChange={(value: any) =>
                                    onchangeImgVideo(
                                      value,
                                      index,
                                      "url",
                                      "video",
                                    )
                                  }
                                  htmlFor={`video-upload-${index}`}
                                  doctype={"video"}
                                />
                                {url ? (
                                  <div className="video-thumbnail-holder">
                                    <video
                                      ref={videoRef}
                                      className="videoClass"
                                      controls
                                      style={{
                                        width: "150px",
                                        height: "100px",
                                      }}
                                    >
                                      <source src={url} type="video/mp4" />
                                      <source
                                        src="movie.ogg"
                                        type="video/ogg"
                                      />
                                      Your browser does not support the video
                                      tag.
                                    </video>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="col-md-4 mb-4">
                          <LabelInput labelName={"Order number"} />
                          <InputField
                            placeholder={`Order  No. ${index + 1}`}
                            setInputText={(value: any) =>
                              onchangeImgVideo(value, index, "order", "")
                            }
                            value={order}
                          />
                        </div>
                        {index === imgVideoArr.length - 1 && (
                          <div
                            className=""
                            style={{
                              width: "135px",
                              position: "absolute",
                              bottom: "5%",
                              right: "0%",
                            }}
                          >
                            <AddMoreBtn handleClick={onPressAdd} />
                          </div>
                        )}
                        {imgVideoArr?.length != 1 ? (
                          <div className="col-1 position-absolute end-0">
                            <DeleteForeverIcon
                              className="text-danger cursor"
                              onClick={() => handleClose(index)}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="row bxshadow p-2 borderRadius mb-4 w-50">
              <LabelInput labelName={"Tag Option"} />
              {tagOptionList.map((item: any, index: any) => {
                const { _id, name } = item;
                return (
                  <div key={item?._id} className="col-md-4 mb-3">
                    <input
                      id={_id}
                      className="check"
                      type="checkbox"
                      checked={tagCheck === name}
                      onChange={(event) => {
                        changeCheckBox(event, index);
                        setTagCheck(name);
                      }}
                    />
                    <span className="checkVal ms-2">{name}</span>
                  </div>
                );
              })}
            </div>
            <div className="row bxshadow p-2 borderRadius mb-4">
              <div className="col-md-6 mb-3">
                <LabelInput labelName={"Brief Description "} />
                <TextEditor
                  onChange={(value: any) => onchangeBriefDesc(value)}
                  value={briefDesc}
                />
              </div>
              <div className="col-md-6 mb-3">
                <LabelInput labelName={"Product Description"} />
                <TextEditor
                  onChange={(value: any) => onchangeProductDesc(value)}
                  value={productDesc}
                />
              </div>
              <div className="col-md-6 mb-3">
                <LabelInput labelName={"Addition Info "} />
                <TextEditor
                  onChange={(value: any) => onchangeAdditionInfo(value)}
                  value={additionInfo}
                />
              </div>
              <div className="col-md-6 mb-3">
                <LabelInput labelName={"Product Video"} />
                <div className="d-flex">
                  <ImagePickerAndViewer
                    value={videoPreview}
                    handleChange={(value: any) => handleProductVideo(value)}
                    htmlFor={`prodict-video-upload`}
                    doctype={"video"}
                  />
                  {videoPreview ? (
                    <div className="video-thumbnail-holder">
                      <video
                        ref={productVideoRef}
                        className="videoClass"
                        controls
                        style={{
                          width: "150px",
                          height: "100px",
                        }}
                      >
                        <source src={videoPreview} type="video/mp4" />
                        <source src="movie.ogg" type="video/ogg" />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="row g-5">
              {descriptionImages.map((item: any, index: any) => {
                const { id, image, order, text, imagePreview } = item;
                return (
                  <div className="col-md-6 mb-3" key={id}>
                    <div className="row bxshadow p-2 borderRadius mb-4 position-relative">
                      <div className="col-md-6 mb-3">
                        <LabelInput
                          labelName={"Product Description Images"}
                          isRequired
                        />
                        <ImgPickerAndViewer
                          value={imagePreview}
                          handleChange={(value: any) =>
                            onchangeProductImage(value, index, "image")
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <LabelInput labelName={"Order number"} />
                        <InputField
                          // key={"ex2"}
                          placeholder={`Order  No. ${index + 1}`}
                          setInputText={(value: any) =>
                            onchangeProductImage(value, index, "order")
                          }
                          value={order}
                        />
                      </div>
                      <div className="col-md-12 mb-3">
                        <LabelInput labelName={"Text"} />
                        <TextEditor
                          onChange={(value: any) =>
                            onchangeProductImage(value, index, "text")
                          }
                          value={text}
                        />
                      </div>
                      {index === descriptionImages?.length - 1 && (
                        <div className="col-md-3 ms-auto text-end">
                          <AddMoreBtn handleClick={onPressAddProductImg} />
                        </div>
                      )}
                      {descriptionImages?.length === 1 ? (
                        ""
                      ) : (
                        <div className="col-1 position-absolute end-0 cursor">
                          <DeleteForeverIcon
                            className="text-danger"
                            onClick={() => handleCloseAddProductImg(index)}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="col-md-2 mx-auto">
              <Submitbtn name={"Save"} disabled={validations()} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddProduct;
